import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'jquery/dist/jquery.min.js';
import 'bootstrap-select/dist/css/bootstrap-select.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap-select/dist/js/bootstrap-select.min.js';
import 'popper.js/dist/umd/popper.min.js';
import 'tooltip.js/dist/tooltip.min.js';
import "@fortawesome/fontawesome-free/css/all.min.css";
import 'react-loading-skeleton/dist/skeleton.css';

import i18n from './components/i18n';
import { I18nextProvider } from 'react-i18next';

import { Provider } from 'react-redux';
import store from './Store'
// import './assets/js/custom.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <I18nextProvider i18n={i18n}>
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  </I18nextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
